import React from 'react';
import getUrlVars from '../../helpers/getUrlVars';
import tabInfo from '../../helpers/tabInfo';

class Vimeo extends React.Component {
  static defaultProps = {
    desktop: false,
  };

  componentWillMount() {
    const getParams = getUrlVars();
    if (getParams.windowTitle && getParams.windowTitle !== 'null') {
      tabInfo.setWindowTitle(decodeURIComponent(getParams.windowTitle));
    }
    if (getParams.faviconUrl && getParams.faviconUrl !== 'null') {
      tabInfo.setFavicon(decodeURIComponent(getParams.faviconUrl));
    }
  }

  render() {
    const { desktop } = this.props;
    const url = decodeURIComponent(getUrlVars()['url']);
    return (
      <div className={desktop ? 'portal-vimeo portal-home darkBckg' : 'portal-vimeo portal-home darkBckg'}>
        <div className={'container'}>
          <div className={'vimeo-player'}>
            <iframe title={`drive-player`} src={url} style={{ border: 'none' }} allowfullscreen="allowfullscreen" />
          </div>
        </div>
      </div>
    );
  }
}

export default Vimeo;



// WEBPACK FOOTER //
// ./src/components/routes/Drive.js